import { useSnackbar } from 'notistack';
import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { sendWebPageAnalytics } from '../../../catalog/Analytics';
import { WebsiteDesignType } from '../../../catalog/enums/WebsiteDesignType';
import { isValidObject } from '../../../catalog/Validity';
import { context } from '../../../globalState/GlobalState';
import { fetchLimitedScheduledGamesAPI, fetchLimitedPreviousGamesAPI } from '../../apiCalls/games/GameAPICalls';
import Schedule1 from '../../designs/schedule1/Schedule1';
import { createCustomTitleTag, createCustomDescriptionTag, createCustomKeywordsTag } from '../uiElements/helmet/MetaTags';
import TitleAndDescriptionTags from '../uiElements/helmet/TitleAndDescriptionTags';

const initialState = {
    previousGames: [],
    scheduledGames: [],
    season: null,
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchGames':
            return { ...state, pastGames: action.games };
        case 'fetchPreviousGames':
            return { ...state, previousGames: action.games };
        case 'fetchScheduledGames':
            return { ...state, scheduledGames: action.games };
        case 'setSeason':
            return { ...state, season: action.season };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const Schedule = () => {
    const history = useHistory();
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        sendWebPageAnalytics(globalState, 'Schedule');
    }, [globalState]);

    useEffect(() => {
        async function fetchGames() {
            if (isValidObject(globalState.accountId)) {
                setState({ type: 'setLoadingSpinner', loadingSpinner: true });
                await fetchLimitedScheduledGamesAPI(globalState.accountId, 200, setState, enqueueSnackbar);
                await fetchLimitedPreviousGamesAPI(globalState.accountId, 200, setState, enqueueSnackbar);
                setState({ type: 'setLoadingSpinner', loadingSpinner: false });
            }
        }

        fetchGames();
    }, [history, globalState.accountId]);

    const getScheduleDesign = () => {
        if (!isValidObject(globalState) || !isValidObject(globalState.websiteStyles)) {
            return null;
        }

        if (globalState.websiteStyles.design.games === WebsiteDesignType.DESIGN_1) {
            return (<Schedule1 season={state.season} previousGames={state.previousGames} scheduledGames={state.scheduledGames} loadingSpinner={state.loadingSpinner} />);
        }
        return null;
    };

    return (
        <>
            <TitleAndDescriptionTags
                title={createCustomTitleTag('Schedule', globalState)}
                pageTitle="Schedule"
                description={createCustomDescriptionTag('Check out our upcoming schedule', globalState)}
                keywords={createCustomKeywordsTag('Schedule', globalState)}
            />
            {getScheduleDesign()}
        </>
    );
};

export default memo(Schedule);
